export const AIRTABLE_BASE = 'apptcB5afPmt171VR';
export const AIRTABLE_APIKEY = 'keyajelld9aZoAKi8';

export const AIRTABLE_URL = `https://api.airtable.com/v0/${AIRTABLE_BASE}`;

